<template>
  <div class="adm-field">
    <label class="adm-label" :for="id">{{ label }} <span class="adm-req">*</span></label>
    <div class="adm-password">
      <div class="adm-password__box">
      <input :id="id" class="adm-input adm-password__input" :class="{ 'is-invalid': error }"
             :type="visible ? 'text' : 'password'" autocomplete="new-password" maxlength="64"
             :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
      <button type="button" class="adm-icon-btn adm-password__toggle" :aria-label="visible ? 'Hide password' : 'Show password'"
              @click="visible = !visible">
        <i class="fas" :class="visible ? 'fa-eye-slash' : 'fa-eye'"></i>
      </button>
      </div>
      <button type="button" class="adm-btn" @click="generate">
        <i class="fas fa-magic"></i> Generate
      </button>
    </div>
    <div v-if="error" class="adm-field__error">{{ error }}</div>
    <div v-else class="adm-field__help">
      8–64 characters with an upper-case letter, a lower-case letter and a number. Share it with the user yourself.
    </div>
  </div>
</template>

<script>
let nextId = 0;

/** Message for a password the API would reject, or "" when it is fine (same rule as auth_service.validate_password). */
export function passwordError(password) {
  if (!password) return "Enter a password.";
  if (password.length < 8 || password.length > 64 || !/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/\d/.test(password)) {
    return "Use 8–64 characters with an upper-case letter, a lower-case letter and a number.";
  }
  return "";
}

function pick(chars) {
  const n = new Uint32Array(1);
  window.crypto.getRandomValues(n);
  return chars[n[0] % chars.length];
}

function randomPassword() {
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lower = "abcdefghijkmnpqrstuvwxyz";
  const digits = "23456789";
  const all = upper + lower + digits + "@#$%&*!?";
  const chars = [pick(upper), pick(lower), pick(digits)];
  while (chars.length < 12) chars.push(pick(all));
  for (let i = chars.length - 1; i > 0; i--) {
    const j = Math.floor((window.crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32) * (i + 1));
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join("");
}

export default {
  name: "PasswordField",
  props: {
    modelValue: { type: String, required: true },
    label: { type: String, default: "Password" },
    error: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  data() {
    return { id: `adm-password-${++nextId}`, visible: false };
  },
  methods: {
    generate() {
      this.visible = true; // so the admin can copy it
      this.$emit("update:modelValue", randomPassword());
    },
  },
};
</script>

<style scoped>
.adm-password {
  display: flex;
  gap: 8px;
}

.adm-password__box {
  position: relative;
  flex: 1;
  min-width: 0;
}

.adm-password__input {
  padding-right: 44px;
}

.adm-password__toggle {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
}
</style>
